export const Z_INDEX = {
  FLOATING_ELEMENTS: 10
};
